import $ from 'jquery';

const $header = $('.header');
const $mega = $('.mega-menu');
const $megaSub = $mega.find('.mega-menu__sub-menu-column');
let mouseEnterTime = 0;
let mouseEnterCallback = null;

let active = {
    $main: null,
    $sub: null
};

$('*[data-mega-menu-target]').on('mouseenter', ev => {
    mouseEnterTime = ev.timeStamp;

    // use a small delay before opening the menu, to avoid overreactive menus
    // that open at the slightest mouse movement
    mouseEnterCallback = window.setTimeout(() => {
        mouseEnterCallback = null;

        closeMainMenu();

        const $item = $(ev.currentTarget);
        let $target;
        try {
            $target = $($item.data('mega-menu-target'));
        } catch (e) {
            return;
        }

        if ($target.length === 0) {
            mouseEnterTime = 0;
            return;
        }

        openMainMenu($target);
    }, 50);

}).on('mouseleave', () => {
    if (mouseEnterCallback !== null) {
        window.clearTimeout(mouseEnterCallback);
        mouseEnterCallback = null;
    }

}).on('click', ev => {
    if (Math.abs(ev.timeStamp - mouseEnterTime) < 100) {
        ev.preventDefault();
    }
});

function openMainMenu($target) {
    $target.removeClass('d-none');
    $mega.addClass('mega-menu--open');
    $header.addClass('header--open');
    active.$main = $target;

    window.setTimeout(() => {
        $mega.addClass('mega-menu--visible');
    }, 0);

    const linkCount = $target.find('.mega-menu__link').length;
    const $link = $target.find('.mega-menu__link--has-submenu');
    if ($link.length === 1 && linkCount === 1) {
        openSubMenu($link);
    }
}

function closeMainMenu() {
    closeSubMenu();
    $header.removeClass('header--open');
    $mega.removeClass('mega-menu--visible');
    $mega.removeClass('mega-menu--open');
    $mega.find('.mega-menu__menu').addClass('d-none');
    active.$main = null;
}

/****
 * submenu
 ****/

$('.mega-menu__link-toggle').on('click', ev => {
    ev.preventDefault();
    closeSubMenu();
    const $link = $(ev.currentTarget).parent();
    openSubMenu($link);
});

function closeSubMenu() {
    $('.mega-menu__sub-div').addClass('d-none');
    $('.mega-menu__link').removeClass('active');
    $megaSub.removeClass('mega-menu__sub-menu-column--visible');
    active.$sub = null;
}

function openSubMenu($link) {
    const $item = $link.parent();
    let $target;
    try {
        $target = $($link.attr('data-target-submenu'));
    } catch (e) {
        return;
    }
    if ($target.length === 0) {
        return;
    }
    $target.removeClass('d-none');
    $link.addClass('active');
    $megaSub.addClass('mega-menu__sub-menu-column--visible');
    active.$sub = $target;
}


$(document).on('click', ev => {
    if ($(window).width() < 992) {
        return;
    }
    if (
        $(ev.target).closest('.mega-menu').length === 0
        && $(ev.target).closest('.desktop-nav__item').length === 0
    ) {
        closeMainMenu();
    }
});

$('.meta-nav__item, .desktop-nav__logo-wrap').on('mouseenter', () => closeMainMenu());


// accessibility stuff
function openTargetedMainMenu($item) {
    closeMainMenu();
    let $target;
    try {
        $target = $($item.data('mega-menu-target'));
    } catch (e) {
        return;
    }
    if ($target.length === 0) {
        return;
    }
    openMainMenu($target);
}

$('*[data-mega-menu-target]').on('keypress', ev => {
    if (ev.code !== 'Space' && ev.key !== ' ') {
        return;
    }
    ev.preventDefault();
    openTargetedMainMenu($(ev.currentTarget))
});

$('*[data-target-submenu]').on('keypress', ev => {
    if (ev.code !== 'Space' && ev.key !== ' ') {
        return;
    }
    ev.preventDefault();
    $(ev.currentTarget).find('.mega-menu__link-toggle').trigger('click');
});


/**
 * #####################################
 * ### Main Menu Keyboard Navigation ###
 * #####################################
 *
 * This is quite complex, handling multiple key events and dealing with multiple sub menus.
 *
 * The main mechanics are:
 *
 * - Main Menu (at the top)
 *   - When focused can move left and right (basically the same as tabbing)
 *   - Pressing down arrow opens the submenu and focuses on the first link within.
 *
 * - Sub Menu (on the left)
 *   - When focused can move up and down (also same as tabbing)
 *  - Pressing right arrow opens the submenu on the right and focuses on the first link within.
 *
 * - Sub Menu (on the right)
 *  - When focused can move up and down (again same as tabbing)
 *  - Pressing right arrow moves to a column to the right (using offset().left/top to determine which link to focus on)
 *  - Pressing left arrow does the same in the other direction, unless it's the first column, then it moves to the
 *    parent link (on the left).
 *
 * If anything ever changes in the code below, please adjust the text above.
 *
 */

$(document).on('keydown', ev => {
    if (!document.activeElement) {
        return;
    }
    const $elem = $(document.activeElement);
    if ($elem.closest('.desktop-nav').length === 0) {
        if (ev.key === 'Tab' && active.$main !== null) {
            // if mouse opened the menu, but we're not focused on it
            // then focus on the first link
            active.$main.find('.mega-menu__link').first().focus();
            ev.preventDefault();
        }
        return;
    }

    const handled = [
        'Escape',
        'ArrowDown', 'ArrowUp',
        'ArrowRight', 'ArrowLeft'
    ];
    if (!handled.includes(ev.key) && !handled.includes(ev.code)) {
        return;
    }

    ev.preventDefault();

    if (ev.key === 'Escape') {
        if (active.$sub !== null) {
            let id = active.$sub.attr('id');
            $('.mega-menu__link[data-target-submenu="#' + id + '"]').first().focus();
            closeSubMenu();
        } else if (active.$main !== null) {
            let id = active.$main.attr('id');
            $('.desktop-nav__link[data-mega-menu-target="#' + id + '"]').first().focus();
            closeMainMenu();
        }
    } else if (ev.key === 'ArrowDown') {

        // if we press down while on focus on a main menu link
        if ($elem.hasClass('desktop-nav__link')) {
            if (active.$main && active.$main.attr('id') === $elem.attr('data-mega-menu-target').substring(1)) {
                active.$main.find('.mega-menu__link').first().focus();
            } else {
                openTargetedMainMenu($elem);
                active.$main.find('.mega-menu__link').first().focus();
            }
        }

        // pressing down on a submenu link (left side)
        if ($elem.hasClass('mega-menu__link')) {
            let $next = $elem.parent().next();
            if ($next.length > 0) {
                $next.find('.mega-menu__link').first().focus();
            }
        }

        // pressing down on a submenu link (right side)
        if ($elem.hasClass('mega-menu__sub-link')) {
            $elem.parent().next().find('.mega-menu__sub-link').first().focus();
        }

    } else if (ev.key === 'ArrowUp') {

        // pressing up on a submenu link (left side)
        if ($elem.hasClass('mega-menu__link')) {
            let $prev = $elem.parent().prev();
            if ($prev.length > 0) {
                $prev.find('.mega-menu__link').first().focus();
            } else {
                let subId = active.$main.attr('id');
                $('.desktop-nav__link[data-mega-menu-target="#' + subId + '"]').first().focus();
            }
        }

        // pressing up on a submenu link (right side)
        if ($elem.hasClass('mega-menu__sub-link')) {
            $elem.parent().prev().find('.mega-menu__sub-link').first().focus();
        }
    } else if (ev.key === 'ArrowRight') {
        // pressing right on a main menu link
        if ($elem.hasClass('desktop-nav__link')) {
            $elem.parent().next().find('.desktop-nav__link').first().focus();
        }

        // pressing right on a submenu link (left side) opens the submenu (right side)
        if ($elem.hasClass('mega-menu__link')) {
            closeSubMenu();
            openSubMenu($elem);
            active.$sub.find('.mega-menu__sub-link').first().focus();
        }

        // pressing right on a submenu link (right side) moves to column to the right
        if ($elem.hasClass('mega-menu__sub-link')) {
            let $parent = $elem.parent();
            let $candidates = $parent.siblings().filter((i, el) => $(el).offset().left > $parent.offset().left);
            let lefts = $candidates.map((i, el) => $(el).offset().left);
            let minLeft = Math.min(...lefts);
            let $next = $candidates.filter((i, el) => $(el).offset().left === minLeft);

            // find element with the closest top offset to current $elem
            let top = $elem.offset().top;
            let $closest = $next.first();
            $next.each((i, el) => {
                if (Math.abs($(el).offset().top - top) < Math.abs($closest.offset().top - top)) {
                    $closest = $(el);
                }
            });

            $closest.find('.mega-menu__sub-link').first().focus();
        }

    } else if (ev.key === 'ArrowLeft') {
        // pressing left on a main menu link
        if ($elem.hasClass('desktop-nav__link')) {
            $elem.parent().prev().find('.desktop-nav__link').first().focus();
        }

        // (pressing left on a submenu link (left side) does nothing)

        // pressing left on a submenu link (right side) moves to column to the left
        // or if we are all the way to the left, move to the parent link.
        if ($elem.hasClass('mega-menu__sub-link')) {
            let $parent = $elem.parent();
            let $candidates = $parent.siblings().filter((i, el) => $(el).offset().left < $parent.offset().left);
            let lefts = $candidates.map((i, el) => $(el).offset().left);
            if (lefts.length > 0) {
                let maxLeft = Math.max(...lefts);
                let $next = $candidates.filter((i, el) => $(el).offset().left === maxLeft);

                // find element with the closest top offset to current $elem
                let top = $elem.offset().top;
                let $closest = $next.first();
                $next.each((i, el) => {
                    if (Math.abs($(el).offset().top - top) < Math.abs($closest.offset().top - top)) {
                        $closest = $(el);
                    }
                });

                $closest.find('.mega-menu__sub-link').first().focus();
            } else {
                // if no lefts are found, move to the parent link (left side)
                let id = $elem.closest('.mega-menu__sub-div').attr('id');
                $('.mega-menu__link[data-target-submenu="#' + id + '"]').first().focus();
            }
        }
    }
});
